import { Component, ElementRef, inject } from '@angular/core';

import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-tab-nav-swiper',
  imports: [],
  templateUrl: './tab-nav-swiper.component.html',
  styleUrl: './tab-nav-swiper.component.scss',
})
export class TabNavSwiperComponent {
  private el = inject(ElementRef);
  private ssrService = inject(SsrService);

  change(type: 'next' | 'prev'): void {
    if (this.ssrService.isServer()) return;
    const items = this.el.nativeElement.querySelectorAll('[data-tab-id]');
    const activeItem = this.el.nativeElement.querySelector('[data-tab-active=true]');
    const activeItemIndex = Array.from(items).indexOf(activeItem);
    let nextItem: HTMLElement | null = null;
    if (type === 'next') {
      nextItem = items[activeItemIndex + 1] || items[0];
    } else if (type === 'prev') {
      nextItem = items[activeItemIndex - 1] || items[items.length - 1];
    }
    if (!nextItem) return;
    activeItem.setAttribute('data-tab-active', 'false');
    document.querySelector('[data-tab-anchor="' + activeItem.getAttribute('data-tab-id') + '"]')?.classList.remove('tab-nav__item--active');
    nextItem.setAttribute('data-tab-active', 'true');
    document.querySelector('[data-tab-anchor="' + nextItem.getAttribute('data-tab-id') + '"]')?.classList.add('tab-nav__item--active');
  }
}
